module.exports = __webpack_public_path__ + "static/media/ContactUsVN.fdda74d6.png";